export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/new.387cc21f.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};